const create = () => import('./create')

export default [
  {
    path: '/abc/create/:id',
    name: 'abc.create',
    component: create,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/features/abc/routes.js